import * as z from 'zod'

import { api } from '../../utils/api'

const InputSchema = z.tuple([z.object({
	currentPassword: z.string().nonempty().min(4),
	newPassword: z.string().nonempty().min(4),
})])

const OutputSchema = z.promise(z.any())

const FunctionSchema = z.function(InputSchema, OutputSchema)

export const ChangeLoggedUserPassword = FunctionSchema.implement(async ({ currentPassword, newPassword }) => await api.put(`/user/logged/password`, { currentPassword, newPassword }))